export class DroitOption {
  constructor(
    public id?: number,
    public optionIdentifier?: string,
    public optionValue?: string,
  ) { }
}
